import type { ComponentProps } from "react"

export type FormProps = Omit<ComponentProps<"form">, "className">

/**
 * A simple Form wrapper that doesn't affect the layout of its children.
 */
export function Form({ children, ...rest }: FormProps) {
  return (
    <form className="contents" {...rest}>
      {children}
    </form>
  )
}
